import { useState, useEffect } from "react";
import * as api from "./api";
import { Svg, Toast, G, A, ALt, P, OK, W, E, ELt, cardS,
  iBack, iSend, iBell, iClock, iX, iPlus, iCheck } from "./shared";

export default function NotifyScreen({ detail, selId, me, setScreen }) {
  var [notifyType, setNotifyType] = useState("initial");
  var [notifyTo, setNotifyTo] = useState({ ceo:true, ref:true, manager:true });
  var [extraRecip, setExtraRecip] = useState([]);
  var [newName, setNewName] = useState("");
  var [newMsgType, setNewMsgType] = useState("A");
  var [newPhone, setNewPhone] = useState("");
  var [newEmail, setNewEmail] = useState("");
  var [channel, setChannel] = useState("sms");
  var [selSenderNum, setSelSenderNum] = useState((me && me.senderNums && me.senderNums.length > 0 && me.senderNums[0]) || (me && me.sharedSenderNums && me.sharedSenderNums[0]) || "");
  var [sendMode, setSendMode] = useState("now");
  var [schedDate, setSchedDate] = useState("");
  var [schedTime, setSchedTime] = useState("09:00");
  var [previewMsg, setPreviewMsg] = useState("");
  var [previewMsgB, setPreviewMsgB] = useState("");
  var [editedMsg, setEditedMsg] = useState("");
  var [msgEditing, setMsgEditing] = useState(false);
  var [sending, setSending] = useState(false);
  var [nToast, setNToast] = useState("");
  function showToast(m) { setNToast(m); setTimeout(function(){ setNToast(""); }, 2500); }
  var [emailSubject, setEmailSubject] = useState("");
  var [emailBody, setEmailBody] = useState("");
  var [sendResult, setSendResult] = useState(null);
  var [recipMsgTypes, setRecipMsgTypes] = useState({});

  var c = detail || {};
  var myNums = (me && me.senderNums && me.senderNums.length > 0) ? me.senderNums : (me && me.sharedSenderNums) || [];

  // 메시지 미리보기 자동 생성
  useEffect(function() {
    if (!selId) return;
    api.generateMessage(selId, notifyType).then(function(data) {
      setPreviewMsg(data.message || "");
      if (!msgEditing) setEditedMsg(data.message || "");
      const fixedBrand = !!data.brand && data.brand !== "roum"; // 올댓벤처스 · 로움법무사사무소 로고 건 — 발신자명·링크·FP용 문구는 서버 값 사용 (2026-09-29 · 법무사 2026-10-31)
      var sName = (fixedBrand && data.senderName) || (me && me.senderName) || (me && me.branding && me.branding.name) || (me && me.brandingName) || (me && me.name) || "관리자";
      var cName = (c && c.name) || "";
      var pName = (c && c.project) || "";
      if (!emailSubject || emailSubject === "") setEmailSubject("[" + (sName||"관리자") + "] " + pName + " 서류 제출 안내");
      // B형 (FP용) 메시지 생성 — 타입별 분기
      var portalUrl = (window.location.origin || "https://roum-partners.com") + "/portal/" + selId;
      var tt = "[" + (sName||"관리자") + "] ";
      var bMsg = "";
      if (notifyType === "initial") {
        bMsg = tt + cName + " " + pName + " 서류 수집 안내\n\n안녕하세요.\n" + pName + " 건으로 " + cName + " 측에 필요서류 제출을 요청드렸습니다.\n\n아래 링크에서 제출현황을 실시간으로 확인하실 수 있으며, 보유하신 자료가 있으시면 대신 제출도 가능합니다.\n\n" + portalUrl;
      } else if (notifyType === "reminder") {
        bMsg = tt + cName + " " + pName + " 서류 수집 안내\n\n안녕하세요.\n\n" + cName + " 측에서 " + pName + " 수행에 필요한 서류를 아직 제출하지 않으셨습니다.\n이에, " + cName + " 측에도 재알람을 드렸으니 업무에 참조해주세요.\n감사합니다.\n\n실시간 제출현황 확인하기\n" + portalUrl;
      } else if (notifyType === "reject") {
        bMsg = tt + cName + " " + pName + " 서류 반려 안내\n\n안녕하세요.\n\n" + cName + "에서 제출한 서류 중 일부가 반려 처리되었습니다.\n" + cName + " 측에도 재제출 안내를 드렸으니 참조 부탁드립니다.\n\n반려 사유 및 현황 확인하기\n" + portalUrl;
      } else if (notifyType === "combo") {
        bMsg = tt + cName + " " + pName + " 서류 수집 안내\n\n안녕하세요.\n\n" + cName + "에서 아직 미제출된 서류가 있으며, 일부 제출 서류는 반려 처리되었습니다.\n" + cName + " 측에도 안내를 드렸으니 참조 부탁드립니다.\n\n제출현황 확인하기\n" + portalUrl;
      } else if (notifyType === "item_change") {
        bMsg = tt + cName + " " + pName + " 추가 필요서류 안내\n\n안녕하세요.\n\n" + pName + " 건의 필요서류가 추가되었습니다.\n" + cName + " 측에도 안내를 드렸으니 참조 부탁드립니다.\n\n변경된 항목 확인하기\n" + portalUrl;
      } else if (notifyType === "miss_change") {
        bMsg = tt + cName + " " + pName + " 미제출 및 추가 필요서류 안내\n\n안녕하세요.\n\n" + pName + " 건의 필요서류가 추가되었으며, 아직 미제출된 서류도 있습니다.\n" + cName + " 측에도 안내를 드렸으니 참조 부탁드립니다.\n\n제출현황 확인하기\n" + portalUrl;
      } else {
        bMsg = tt + cName + " " + pName + " 서류 수집 안내\n\n안녕하세요.\n\n아래 링크에서 제출현황을 확인하실 수 있습니다.\n\n" + portalUrl;
      }
      setPreviewMsgB((fixedBrand && data.messageB) || bMsg);
    }).catch(function(e) { console.error(e); });
  }, [selId, notifyType]);

  var types = [
    { key:"initial", label:"최초 안내", desc:"전체 수집 항목 안내" },
    { key:"reminder", label:"리마인더", desc:"미제출 항목만 안내" },
    { key:"reject", label:"반려 안내", desc:"반려 항목 + 사유 안내" },
    { key:"combo", label:"미제출 + 반려", desc:"미제출/반려 항목 동시 안내" },
    { key:"item_change", label:"추가 서류 안내", desc:"필요서류 추가 알림" },
    { key:"miss_change", label:"미제출 + 추가", desc:"필요서류 추가 + 미제출 안내" },
  ];

  // 수신자 계산 + 메시지 유형
  var recipients = [];
  var hasCeoOrMgr = (notifyTo.ceo && c.ceo && c.ceo_phone) || (notifyTo.manager && c.manager && c.manager_phone);
  if (notifyTo.ceo && c.ceo) recipients.push({ name:c.ceo+" 대표", phone:c.ceo_phone, email:c.ceo_email, msgType:"A" });
  if (notifyTo.manager && c.manager) recipients.push({ name:c.manager, phone:c.manager_phone, email:c.manager_email, msgType:"A" });
  if (notifyTo.ref && c.referrer) recipients.push({ name:c.referrer, phone:c.ref_phone, email:c.ref_email, msgType:hasCeoOrMgr?"B":"A" });
  recipients = recipients.concat(extraRecip.filter(function(r){return r.active!==false;}).map(function(r){return Object.assign({},r,{msgType:r.msgType||"A"});}));

  function addRecip() {
    if (!newName.trim()) return;
    setExtraRecip(function(p) { return p.concat([{ name:newName.trim(), phone:newPhone.trim(), email:newEmail.trim(), msgType:newMsgType }]); });
    setNewName(""); setNewPhone(""); setNewEmail("");
  }

  async function doSend() {
    if (recipients.length === 0) { showToast("수신자를 선택해주세요."); return; }
    setSending(true);
    try {
      var scheduledAt = null;
      if (sendMode === "schedule" && schedDate) {
        scheduledAt = new Date(schedDate + "T" + schedTime).toISOString();
      }
      var isScheduled = !!scheduledAt;
      var sendResults = [];
      // A형/B형 수신자 분리
      var recipientsA = recipients.filter(function(r){return r.msgType!=="B";});
      var recipientsB = recipients.filter(function(r){return r.msgType==="B";});

      var htmlBody = "<div style='font-family:sans-serif;max-width:600px;margin:0 auto;'>" +
          "<h2 style='color:#2E75B6;'>" + emailSubject + "</h2>" +
          "<pre style='white-space:pre-wrap;font-family:inherit;line-height:1.8;font-size:14px;'>" +
          (editedMsg || previewMsg) + "</pre>" +
          "<hr style='border:none;border-top:1px solid #eee;margin:20px 0;'/>" +
          "<p style='font-size:12px;color:#888;'>본 메일은 자동 발송된 메일입니다.</p></div>";

      var htmlBodyB = "<div style='font-family:sans-serif;max-width:600px;margin:0 auto;'>" +
          "<h2 style='color:#2E75B6;'>" + emailSubject + "</h2>" +
          "<pre style='white-space:pre-wrap;font-family:inherit;line-height:1.8;font-size:14px;'>" +
          previewMsgB + "</pre>" +
          "<hr style='border:none;border-top:1px solid #eee;margin:20px 0;'/>" +
          "<p style='font-size:12px;color:#888;'>본 메일은 자동 발송된 메일입니다.</p></div>";

      // A형 발송
      if (recipientsA.length > 0) {
        var resp = await api.sendNotification({
          projectId: selId, type: notifyType,
          recipients: recipientsA, channel: channel,
          senderNum: selSenderNum,
          messageSms: editedMsg || undefined,
          emailSubject: emailSubject || undefined,
          messageEmail: htmlBody,
          scheduledAt: scheduledAt,
        });
        if (!isScheduled) sendResults = sendResults.concat(resp.results || []);
      }

      // B형 발송
      if (recipientsB.length > 0) {
        var respB = await api.sendNotification({
          projectId: selId, type: notifyType,
          recipients: recipientsB, channel: channel,
          senderNum: selSenderNum,
          messageSms: previewMsgB,
          emailSubject: emailSubject || undefined,
          messageEmail: htmlBodyB,
          scheduledAt: scheduledAt,
        });
        if (!isScheduled) sendResults = sendResults.concat(respB.results || []);
      }

      if (sendMode === "schedule") {
        /* toast handled by result popup */
        if (setScreen) setScreen("detail");
      } else {
        setSendResult(sendResults);
      }
    } catch(e) { showToast("발송 오류: "+e.message); }
    setSending(false);
  }

  return (
    <div style={{ maxWidth:700, margin:"0 auto", padding:"24px 16px 80px" }}>
      <button onClick={function(){setScreen("detail");}} style={{ background:"none",border:"none",cursor:"pointer",display:"flex",alignItems:"center",gap:5,color:G[500],fontSize:13,padding:0,marginBottom:16 }}>
        <Svg d={iBack} s={15} c={G[500]} /> {c.name || "프로젝트"} 상세로
      </button>

      <h1 style={{ fontSize:20,fontWeight:700,color:G[900],margin:"0 0 4px" }}>알림 발송</h1>
      <p style={{ fontSize:12,color:G[500],margin:"0 0 20px" }}>{c.name} — {c.project}</p>

      {/* 1. 알림 유형 */}
      <div style={cardS}>
        <div style={{ fontSize:13,fontWeight:700,color:G[900],marginBottom:12 }}>1. 알림 유형</div>
        <div style={{ display:"grid",gridTemplateColumns:"1fr 1fr",gap:6 }}>
          {types.map(function(t) {
            var sel = notifyType === t.key;
            return (
              <button key={t.key} onClick={function(){setNotifyType(t.key);setMsgEditing(false);}}
                style={{ padding:"10px 14px",borderRadius:10,border:sel?"1.5px solid "+A:"1px solid "+G[200],background:sel?ALt:"#fff",textAlign:"left",cursor:"pointer" }}>
                <div style={{ fontSize:12,fontWeight:600,color:sel?A:G[700] }}>{t.label}</div>
                <div style={{ fontSize:10,color:G[400],marginTop:2 }}>{t.desc}</div>
              </button>
            );
          })}
        </div>
      </div>

      {/* 2. 수신자 */}
      <div style={cardS}>
        <div style={{ fontSize:13,fontWeight:700,color:G[900],marginBottom:12 }}>2. 수신자</div>
        <div style={{ display:"flex",flexWrap:"wrap",gap:8,marginBottom:10 }}>
          {c.ceo && (
            <label style={{ display:"flex",alignItems:"center",gap:4,fontSize:12,color:G[700],cursor:"pointer" }}>
              <input type="checkbox" checked={notifyTo.ceo} onChange={function(){setNotifyTo(function(p){return Object.assign({},p,{ceo:!p.ceo});});}} />
              {c.ceo} 대표 {c.ceo_phone ? "("+c.ceo_phone+")" : ""} <span style={{ fontSize:10,color:A,fontWeight:600,marginLeft:2 }}>A형</span>
            </label>
          )}
          {c.manager && (
            <label style={{ display:"flex",alignItems:"center",gap:4,fontSize:12,color:G[700],cursor:"pointer" }}>
              <input type="checkbox" checked={notifyTo.manager} onChange={function(){setNotifyTo(function(p){return Object.assign({},p,{manager:!p.manager});});}} />
              {c.manager} {c.manager_phone ? "("+c.manager_phone+")" : ""} <span style={{ fontSize:10,color:A,fontWeight:600,marginLeft:2 }}>A형</span>
            </label>
          )}
          {c.referrer && (
            <label style={{ display:"flex",alignItems:"center",gap:4,fontSize:12,color:G[700],cursor:"pointer" }}>
              <input type="checkbox" checked={notifyTo.ref} onChange={function(){setNotifyTo(function(p){return Object.assign({},p,{ref:!p.ref});});}} />
              {c.referrer} {c.ref_phone ? "("+c.ref_phone+")" : ""} <span style={{ fontSize:10,color:"#D97706",fontWeight:600,marginLeft:2 }}>{hasCeoOrMgr?"B형":"A형"}</span>
            </label>
          )}
        </div>

        {/* 추가 수신자 */}
        {extraRecip.map(function(r, i) {
          return (
            <div key={i} style={{ display:"flex",alignItems:"center",gap:8,marginBottom:6 }}>
              <input type="checkbox" checked={r.active!==false} onChange={function(){var idx=i;setExtraRecip(function(p){return p.map(function(x,j){return j===idx?Object.assign({},x,{active:x.active===false?true:false}):x;});});}} />
              <span style={{ fontSize:12,color:G[700],fontWeight:500 }}>{r.name}</span>
              <span style={{ fontSize:10,color:r.msgType==="B"?"#D97706":A,fontWeight:700 }}>{r.msgType||"A"}형</span>{r.phone && <span style={{ fontSize:11,color:G[500] }}>{r.phone}</span>}
              {r.email && <span style={{ fontSize:11,color:G[400] }}>{r.email}</span>}
              <button onClick={function(){var idx=i;setExtraRecip(function(p){return p.filter(function(_,j){return j!==idx;});});}} style={{ background:"none",border:"none",cursor:"pointer",marginLeft:"auto" }}><Svg d={iX} s={12} c={G[400]} /></button>
            </div>
          );
        })}
        <div style={{ padding:"8px 10px",background:G[50],borderRadius:6,marginTop:8,marginBottom:8,fontSize:11,color:G[600],lineHeight:1.5 }}>
          <strong>A형</strong>: 자료 제출 요청 메시지 (대표자/담당자용)<br/>
          <strong>B형</strong>: 참고 안내 + 대리 제출 가능 메시지 (소개자/FP용)
        </div>
        <div style={{ display:"flex",gap:6,marginTop:6,alignItems:"center",flexWrap:"wrap" }}>
          <input value={newName} onChange={function(e){setNewName(e.target.value);}} placeholder="이름" style={{ width:80,padding:"6px 8px",border:"1px solid "+G[200],borderRadius:6,fontSize:11,outline:"none" }} />
          <input value={newPhone} onChange={function(e){setNewPhone(e.target.value);}} placeholder="연락처" style={{ width:110,padding:"6px 8px",border:"1px solid "+G[200],borderRadius:6,fontSize:11,outline:"none" }} />
          <input value={newEmail} onChange={function(e){setNewEmail(e.target.value);}} placeholder="이메일" style={{ width:140,padding:"6px 8px",border:"1px solid "+G[200],borderRadius:6,fontSize:11,outline:"none" }} />
          <select value={newMsgType} onChange={function(e){setNewMsgType(e.target.value);}} style={{ padding:"5px 6px",border:"1px solid "+G[200],borderRadius:6,fontSize:11,background:"#fff" }}><option value="A">A형</option><option value="B">B형</option></select><button onClick={addRecip} style={{ padding:"6px 10px",borderRadius:6,border:"1px solid "+G[200],background:"#fff",color:G[600],fontSize:11,cursor:"pointer" }}>+ 추가</button>
        </div>
      </div>

      {/* 3. 발송 채널 */}
      <div style={cardS}>
        <div style={{ fontSize:13,fontWeight:700,color:G[900],marginBottom:12 }}>3. 발송 채널</div>
        <div style={{ display:"flex",gap:8 }}>
          {["sms","email","both"].map(function(ch) {
            var labels = { sms:"SMS", email:"이메일", both:"SMS + 이메일" };
            var sel = channel === ch;
            return (
              <button key={ch} onClick={function(){setChannel(ch);}}
                style={{ padding:"8px 16px",borderRadius:8,border:sel?"1.5px solid "+A:"1px solid "+G[200],background:sel?ALt:"#fff",color:sel?A:G[600],fontSize:12,fontWeight:sel?600:500,cursor:"pointer" }}>
                {labels[ch]}
              </button>
            );
          })}
        </div>
        {(channel === "sms" || channel === "both") && myNums.length > 0 && (
          <div style={{ marginTop:10 }}>
            <label style={{ fontSize:11,fontWeight:600,color:G[500],display:"block",marginBottom:4 }}>발신번호</label>
            <select value={selSenderNum} onChange={function(e){setSelSenderNum(e.target.value);}} style={{ padding:"8px 12px",border:"1px solid "+G[200],borderRadius:8,fontSize:12,background:"#fff" }}>
              {myNums.map(function(n) { return <option key={n} value={n}>{n}</option>; })}
            </select>
          </div>
        )}
      </div>

      {/* 4. 메시지 미리보기 */}
      <div style={cardS}>
        <div style={{ display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10 }}>
          <span style={{ fontSize:13,fontWeight:700,color:G[900] }}>4. 메시지 미리보기</span>
          <button onClick={function(){setMsgEditing(!msgEditing);}} style={{ padding:"4px 10px",borderRadius:6,border:"1px solid "+G[200],background:"#fff",color:G[600],fontSize:11,cursor:"pointer" }}>
            {msgEditing?"자동 생성":"직접 수정"}
          </button>
        </div>
        {(channel === "email" || channel === "both") && (
          <div style={{ marginBottom:10 }}>
            <label style={{ fontSize:11,fontWeight:600,color:G[500],display:"block",marginBottom:4 }}>이메일 제목</label>
            <input value={emailSubject} onChange={function(e){setEmailSubject(e.target.value);}} style={{ width:"100%",padding:"8px 12px",border:"1.5px solid "+G[200],borderRadius:8,fontSize:13,outline:"none",boxSizing:"border-box" }} />
          </div>
        )}
        {msgEditing ? (
          <textarea value={editedMsg} onChange={function(e){setEditedMsg(e.target.value);}} rows={8}
            style={{ width:"100%",padding:"12px",border:"1.5px solid "+A,borderRadius:10,fontSize:12,lineHeight:1.6,outline:"none",resize:"vertical",boxSizing:"border-box",fontFamily:"inherit" }} />
        ) : (
          <div>
            {recipients.some(function(r){return r.msgType==="B";}) ? (
              <div style={{ display:"grid",gridTemplateColumns:"1fr 1fr",gap:10 }}>
                <div>
                  <div style={{ fontSize:11,fontWeight:600,color:A,marginBottom:6 }}>A형 (대표자/담당자)</div>
                  <div style={{ padding:"12px",background:G[50],borderRadius:10,border:"1px solid "+G[200],fontSize:12,color:G[700],whiteSpace:"pre-wrap",lineHeight:1.6 }}>{previewMsg || "메시지를 생성 중..."}</div>
                </div>
                <div>
                  <div style={{ fontSize:11,fontWeight:600,color:"#D97706",marginBottom:6 }}>B형 (소개자/FP)</div>
                  <div style={{ padding:"12px",background:"#FFFBEB",borderRadius:10,border:"1px solid #FDE68A",fontSize:12,color:G[700],whiteSpace:"pre-wrap",lineHeight:1.6 }}>{previewMsgB || "메시지를 생성 중..."}</div>
                </div>
              </div>
            ) : (
              <div style={{ padding:"14px",background:G[50],borderRadius:10,border:"1px solid "+G[200],fontSize:12,color:G[700],whiteSpace:"pre-wrap",lineHeight:1.6 }}>
                {previewMsg || "메시지를 생성 중..."}
              </div>
            )}
          </div>
        )}
      </div>

      {/* 5. 발송 */}
      <div style={cardS}>
        <div style={{ fontSize:13,fontWeight:700,color:G[900],marginBottom:12 }}>5. 발송</div>
        <div style={{ display:"flex",gap:8,marginBottom:12 }}>
          <button onClick={function(){setSendMode("now");}} style={{ padding:"8px 16px",borderRadius:8,border:sendMode==="now"?"1.5px solid "+A:"1px solid "+G[200],background:sendMode==="now"?ALt:"#fff",color:sendMode==="now"?A:G[600],fontSize:12,fontWeight:sendMode==="now"?600:500,cursor:"pointer" }}>즉시 발송</button>
          <button onClick={function(){setSendMode("schedule");}} style={{ padding:"8px 16px",borderRadius:8,border:sendMode==="schedule"?"1.5px solid "+A:"1px solid "+G[200],background:sendMode==="schedule"?ALt:"#fff",color:sendMode==="schedule"?A:G[600],fontSize:12,fontWeight:sendMode==="schedule"?600:500,cursor:"pointer",display:"flex",alignItems:"center",gap:4 }}>
            <Svg d={iClock} s={13} c={sendMode==="schedule"?A:G[400]} /> 예약
          </button>
        </div>
        {sendMode === "schedule" && (
          <div style={{ display:"flex",gap:8,marginBottom:12 }}>
            <input type="date" value={schedDate} onChange={function(e){setSchedDate(e.target.value);}} style={{ padding:"8px 12px",border:"1px solid "+G[200],borderRadius:8,fontSize:12 }} />
            <input type="time" value={schedTime} onChange={function(e){setSchedTime(e.target.value);}} style={{ padding:"8px 12px",border:"1px solid "+G[200],borderRadius:8,fontSize:12 }} />
          </div>
        )}

        {/* 요약 */}
        <div style={{ padding:"10px 14px",background:G[50],borderRadius:8,marginBottom:14,fontSize:12,color:G[600] }}>
          수신: <strong>{recipients.length}명</strong> · 채널: <strong>{channel==="sms"?"SMS":channel==="email"?"이메일":"SMS+이메일"}</strong>
          {sendMode==="schedule" && schedDate && <span> · 예약: <strong>{schedDate} {schedTime}</strong></span>}
        </div>

        <button onClick={doSend} disabled={recipients.length===0||sending}
          style={{ width:"100%",padding:"14px 0",borderRadius:10,border:"none",
            background:recipients.length>0&&!sending?"linear-gradient(135deg,"+A+","+P+")":G[300],
            color:"#fff",fontSize:15,fontWeight:700,cursor:recipients.length>0&&!sending?"pointer":"not-allowed",
            display:"flex",alignItems:"center",justifyContent:"center",gap:8 }}>
          <Svg d={iSend} s={18} c="#fff" />
          {sending?"발송 중...":sendMode==="schedule"?"예약 발송":"지금 발송"}
        </button>
      </div>

      {/* 발송 결과 팝업 */}
      {sendResult && (function() {
        var smsTotal = sendResult.filter(function(r){return r.smsOk !== null;}).length;
        var smsOk = sendResult.filter(function(r){return r.smsOk === true;}).length;
        var smsFail = smsTotal - smsOk;
        var emailTotal = sendResult.filter(function(r){return r.emailOk !== null;}).length;
        var emailOk = sendResult.filter(function(r){return r.emailOk === true;}).length;
        var emailFail = emailTotal - emailOk;
        return (
          <div style={{ position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,.4)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center" }}>
            <div style={{ background:"#fff",borderRadius:16,padding:"28px 24px",maxWidth:460,width:"92%",boxShadow:"0 20px 60px rgba(0,0,0,.2)",maxHeight:"80vh",overflow:"auto" }}>
              <h3 style={{ fontSize:17,fontWeight:700,color:G[900],marginBottom:16,textAlign:"center" }}>📨 발송 결과</h3>
              <div style={{ display:"flex",gap:12,marginBottom:16,justifyContent:"center" }}>
                {smsTotal > 0 && <div style={{ textAlign:"center",padding:"12px 20px",background:smsFail===0?"#ECFDF5":"#FEF2F2",borderRadius:10,minWidth:100 }}>
                  <div style={{ fontSize:12,color:G[500],marginBottom:4 }}>SMS</div>
                  <div style={{ fontSize:20,fontWeight:700,color:smsFail===0?OK:W }}>{smsOk}/{smsTotal}</div>
                  <div style={{ fontSize:11,color:smsFail>0?E:OK }}>{smsFail>0?"실패 "+smsFail+"건":"전체 성공"}</div>
                </div>}
                {emailTotal > 0 && <div style={{ textAlign:"center",padding:"12px 20px",background:emailFail===0?"#ECFDF5":"#FEF2F2",borderRadius:10,minWidth:100 }}>
                  <div style={{ fontSize:12,color:G[500],marginBottom:4 }}>이메일</div>
                  <div style={{ fontSize:20,fontWeight:700,color:emailFail===0?OK:W }}>{emailOk}/{emailTotal}</div>
                  <div style={{ fontSize:11,color:emailFail>0?E:OK }}>{emailFail>0?"실패 "+emailFail+"건":"전체 성공"}</div>
                </div>}
              </div>
              <div style={{ fontSize:12,fontWeight:600,color:G[700],marginBottom:8 }}>수신자별 상세</div>
              <div style={{ border:"1px solid "+G[200],borderRadius:8,overflow:"hidden" }}>
                {sendResult.map(function(r, i) {
                  return <div key={i} style={{ display:"flex",alignItems:"center",gap:8,padding:"8px 12px",borderBottom:i<sendResult.length-1?"1px solid "+G[100]:"none",fontSize:12 }}>
                    <span style={{ flex:1,fontWeight:500,color:G[700] }}>{r.name}</span>
                    {r.smsOk !== null && <span style={{ fontSize:11,fontWeight:600,color:r.smsOk?OK:E,background:r.smsOk?"#ECFDF5":"#FEF2F2",padding:"2px 8px",borderRadius:4 }}>SMS {r.smsOk?"✓":"✗"}</span>}
                    {r.smsOk === false && r.smsMsg && <span style={{ fontSize:10,color:E }}>{r.smsMsg}</span>}
                    {r.emailOk !== null && <span style={{ fontSize:11,fontWeight:600,color:r.emailOk?OK:E,background:r.emailOk?"#ECFDF5":"#FEF2F2",padding:"2px 8px",borderRadius:4 }}>Email {r.emailOk?"✓":"✗"}</span>}
                    {r.emailOk === false && r.emailMsg && <span style={{ fontSize:10,color:E }}>{r.emailMsg}</span>}
                  </div>;
                })}
              </div>
              <button onClick={function(){setSendResult(null);if(setScreen)setScreen("detail");}} style={{ width:"100%",marginTop:16,padding:"12px 0",borderRadius:10,border:"none",background:"linear-gradient(135deg,"+A+","+P+")",color:"#fff",fontSize:14,fontWeight:600,cursor:"pointer" }}>확인</button>
            </div>
          </div>
        );
      })()}
      <Toast msg={nToast} />
    </div>
  );
}
